// Control characters are intentionally rejected in public-facing identity fields.
// eslint-disable-next-line no-control-regex
const UNSAFE_PROFILE_FORMATTING = /[\u0000-\u001f\u007f-\u009f\u200b-\u200f\u202a-\u202e\u2060\u2066-\u2069\ufeff]/u;

export function normalizeProfileText(value: string | null | undefined, label: string, maxLength: number) {
  const normalized = String(value ?? "").normalize("NFKC").trim();
  if (!normalized) return null;

  if (Array.from(normalized).length > maxLength) {
    throw new Error(`${label} must be ${maxLength} characters or fewer.`);
  }

  if (UNSAFE_PROFILE_FORMATTING.test(normalized)) {
    throw new Error(`${label} contains unsupported invisible or formatting characters.`);
  }

  return normalized;
}

export function normalizeDisplayName(value: string | null | undefined) {
  return normalizeProfileText(value, "Display name", 50);
}

export function normalizeProfileLocation(value: string | null | undefined) {
  return normalizeProfileText(value, "Location", 120);
}
